import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/header"
import {useTemplatedComponent} from "@next/templating"
import {LinkProps} from "@mui/material"
import connect from "./connect"

type MyAccountUsernameLinkContainerProps = LinkProps & {
    mainTemplate: string
    fallbackTemplate: string
    props?: any
}

export const MyAccountUsernameLinkContainer = memo(
    ({mainTemplate, fallbackTemplate, children, props}: MyAccountUsernameLinkContainerProps) => {
        const ComponentName = useTemplatedComponent({mainTemplate, fallbackTemplate}, MANIFEST)

        return (
            <Suspense fallback={<div />}>
                <ComponentName role="link" {...props}>
                    {children}
                </ComponentName>
            </Suspense>
        )
    },
)
MyAccountUsernameLinkContainer.displayName = "MyAccountUsernameLinkContainer"

export default connect(MyAccountUsernameLinkContainer)
